(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TicketsMean', TicketsMean);

    TicketsMean.$inject = ['$resource'];

    function TicketsMean ($resource) {
        var resourceUrl =  '/api/findMean';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
